window.swipe = (function() {
    return {

        _xtouchStart: null,
        _ytouchStart: null,
        mounted: function() {
            this.$el.addEventListener('touchstart', this.handleTouchStart);
            this.$el.addEventListener('touchmove', this.handleTouchMove);
        },
        methods: {
            initSwipe : function (element) {
                if(element){
                    element.addEventListener('touchstart', this.handleTouchStart);
                    element.addEventListener('touchmove', this.handleTouchMove);
    
                    element.addEventListener('mousedown', this.handleMouseStart);
                    element.addEventListener('mousemove', this.handleMouseMove);
                } else {
                }
            },

            handleMouseStart : function(evt){
                this._xtouchStart = evt.clientX;
                this._ytouchStart = evt.clientY;
            },
    
            handleTouchStart: function (evt) {
                this._xtouchStart = evt.touches[0].clientX;
                this._ytouchStart = evt.touches[0].clientY;
            },
    
            handleTouchStart: function(evt) {
                this.$options._xtouchStart = evt.touches[0].clientX;
                this.$options._ytouchStart = evt.touches[0].clientY;
            },

            handleTouchMove: function(evt) {
                if (!this.$options._xtouchStart || !this.$options._ytouchStart) {
                    return;
                }

                var xUp = evt.touches[0].clientX;
                var yUp = evt.touches[0].clientY;

                var xDiff = this.$options._xtouchStart - xUp;
                var yDiff = this.$options._ytouchStart - yUp;

                if (Math.abs(xDiff) > Math.abs(yDiff)) { /*most significant*/
                    if (xDiff > 0) {
                        /* left swipe */
                        this.onSwipe && this.onSwipe("right");
                    } else {
                        /* right swipe */
                        this.onSwipe && this.onSwipe("left");
                    }
                } else {
                    if (yDiff > 0) {
                        /* up swipe */
                        this.onSwipe && this.onSwipe("down");
                    } else {
                        /* down swipe */
                        this.onSwipe && this.onSwipe("up");
                    }
                }
                /* reset values */
                this.$options._xtouchStart = null;
                this.$options._ytouchStart = null;
            },
            handleMouseMove: function (evt) {
                if(evt.buttons !==1){
                    return;
                }
                var xUp = evt.clientX;
                var yUp = evt.clientY;
                this._handleSwipe(xUp, yUp);
            },
    
            _handleSwipe : function(xUp, yUp){
                if (!this._xtouchStart || !this._ytouchStart) {
                    return;
                }
                var xDiff = this._xtouchStart - xUp;
                var yDiff = this._ytouchStart - yUp;
                if (Math.abs(xDiff) > Math.abs(yDiff)) { /*most significant*/
                    if (xDiff > 0) {
                        /* left swipe */
                        this.onSwipe && this.onSwipe("right");
                    } else {
                        /* right swipe */
                        this.onSwipe && this.onSwipe("left");
                    }
                } else {
                    if (yDiff > 0) {
                        /* up swipe */
                        this.onSwipe && this.onSwipe("down");
                    } else {
                        /* down swipe */
                        this.onSwipe && this.onSwipe("up");
                    }
                }
                /* reset values */
                this._xtouchStart = null;
                this._ytouchStart = null;
            }
        }
    }
})();
